export const AutopayIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="-1 -1 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7L3.80662 3.84255C4.5657 2.98859 5.65372 2.5 6.79627 2.5H7"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 15.5002L6.5 15.5L10.5 12.5002C10.5 12.5002 11.3091 11.9528 12.5 11.0001C15 9.00015 12.5 5.83347 10 7.49965C7.96409 8.85645 6 10.0003 6 10.0003"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 9.5V3C7 1.89543 7.89543 1 9 1H19C20.1046 1 21 1.89543 21 3V9C21 10.1046 20.1046 11 19 11H12.5"
      stroke="#444444"
      strokeWidth="1.5"
    />
    <path
      d="M14 8C12.8954 8 12 7.1046 12 6C12 4.89543 12.8954 4 14 4C15.1046 4 16 4.89543 16 6C16 7.1046 15.1046 8 14 8Z"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 6.01013L18.51 5.99902"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 6.01013L9.51 5.99902"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
